/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {WarningInlineComponent} from './warning-inline/warning-inline.component';
import {WarningStarComponent} from './warning-star/warning-star.component';
import {WarningInfoComponent} from './warning-info/warning-info.component';
import {TooltipModule} from '../tooltip/tooltip.module';
import {WarningBoxComponent} from './warning-box/warning-box.component';

@NgModule({
    declarations: [
        WarningInlineComponent,
        WarningStarComponent,
        WarningInfoComponent,
        WarningBoxComponent
    ],
    imports: [
        CommonModule,
        TooltipModule
    ],
    exports: [
        WarningInlineComponent,
        WarningStarComponent,
        WarningInfoComponent,
        WarningBoxComponent
    ]
})
export class WarningsModule {
}
